<template>
  <Menu />
  <section v-if="error">
    <p class="error">Lo sentimos hubo un error al cargar los datos.</p>
  </section>
  <section v-if="loading">
    <PaginaCarga />
  </section>
  <section v-else id="Servicios">
    <div id="bloqueSuperior">
      <div id="bloqueSuperior__texto">
        <p id="bloqueSuperior__texto--learndativity">
          {{ jsonServicios.titulo }}
        </p>
        <p
          id="bloqueSuperior__texto--descripcion"
          v-for="subtitulo in jsonServicios.subtitulos"
          :key="subtitulo"
        >
          {{ subtitulo.es }}
        </p>
      </div>
    </div>
  </section>
  <section id="bloqueUnoServicios" class="bloqueUnoServicios">
    <div v-for="item in jsonServicios.bloques" :key="item">
      <ServiciosBloqueUno :datos-bloques="item" />
    </div>
  </section>

  <Footer />
</template>

<script>
import Menu from "@/components/menu/MenuPrincipal.vue";
import Footer from "@/components/footer/FooterPrincipal.vue";
import ServiciosBloqueUno from "@/components/serviciosBloqueUno/ServiciosBloqueUno.vue";
import PaginaCarga from "@/components/paginaCarga/paginaCarga.vue";

import { useQuery } from "@vue/apollo-composable";
import Paginas from "../graphql/Paginas.gql";
import { computed } from "vue";

export default {
  name: "Home",
  components: {
    Menu,
    Footer,
    ServiciosBloqueUno,
    PaginaCarga,
  },
  setup() {
    const { result, loading, error } = useQuery(Paginas.getServicios);
    const jsonServicios = computed(() => result.value?.getServicios ?? []);

    return { jsonServicios, loading, error };
  },
};
</script>
